<script lang="ts" setup>
const {
  title = undefined,
  titleAlign = 'left',
  hideClose = false,
} = defineProps<{
  title?: string
  titleAlign?: 'left' | 'center'
  hideClose?: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

defineSlots<{
  title(): void
  default(): void
  actions(): void
  tabs(): void
}>()
</script>

<template>
  <div
    class="bg-general-base rounded"
    data-test="dialog-card"
  >
    <div
      class="text-headings-h4 text-general-primary flex items-center justify-between gap-6 px-6 pt-6 font-bold"
      :class="{
        'justify-center': titleAlign === 'center',
        'border-general-medium border-b pb-6': !$slots.tabs,
        'pb-0': $slots.tabs,
      }"
      data-test="header"
    >
      <div data-test="title">
        <slot name="title"> {{ title }}</slot>
      </div>
      <VButton
        class="-mt-1 shrink-0"
        :icon="'close'"
        size="small"
        variant="text"
        :class="{ 'pointer-events-none opacity-0': hideClose }"
        data-test="close-button"
        @click="emit('close')"
      />
    </div>
    <slot name="tabs" />
    <div
      class="text-body-medium text-general-primary p-6 text-left"
      data-test="content"
    >
      <slot />
    </div>
    <div
      v-if="$slots.actions"
      class="border-general-medium flex items-center justify-end gap-2 border-t p-6"
      data-test="actions"
    >
      <slot name="actions" />
    </div>
  </div>
</template>
